import { PaymentEditAddI18n, PaymentEditListI18n } from './payment-edit';
import { PurchaseAgreementI18n } from './purchase-agreement.i18n';
import { PurchaseDetailsI18n } from './purchase-details.i18n';
import { PurchaseDoneI18n } from './purchase-done.i18n';
import { PurchaseMethodsI18n } from './purchase-methods.i18n';
import { PurchasePaymentI18n } from './purchase-payment.i18n';
import { PurchaseRegCfI18n } from './purchase-regcf.i18n';

export const PurchaseI18n = {
    dwpf: {
        agreement: PurchaseAgreementI18n,
        details: PurchaseDetailsI18n,
        done: PurchaseDoneI18n,
        methods: PurchaseMethodsI18n,
        notifications: {
            cancel_purchase_fail: 'There was an error cancelling the Purchase. - Override',
            load_bank_account_fail: 'Failed to load Bank Account information - Override',
            load_account_balance_fail: 'Failed to load Account Balance information - Override',
            load_credit_card_fail: 'Failed to load Credit Card information - Override',
            save_bank_account_fail: 'Failed to save Bank Account information - Override',
            delete_credit_card_fail: 'Failed to delete Credit Card - Override',
            save_credit_card_fail: 'Failed to save Credit Card information - Override',
            submit_purchase_fail: 'There was an error submitting the Purchase. - Override',
            submit_purchase_success: 'Purchase successfully submitted - Override',
            purchase_start_fail: 'Could not start the session - Override',
            plaid_on_link_success: `The bank account you're using to add funds to your account balance will be utilized to receive dividends. You can change it later on Account page.`,
            load_plaid_link_fail: 'Failed to load Plaid link - Override',
            load_stripe_cc_link_fail: 'Failed to load Stripe link - Override',
            plaid_on_link_fail: 'There was an error linking bank account - Override',
            stripe_on_link_fail: 'There was an error linking credit card - Override',
        },
        parent: {
            links: {
                pfLink: `/buy-shares`,
                vfLink: `/verification`,
                backLink: {
                    text: 'Back to Listing Details - Override',
                    confirmation: {
                        title: 'Are you sure you want to exit? - Override',
                        text: 'Your purchase will not be completed if you leave this page. - Override',
                    },
                },
            },
            steps: {
                detailsLabel: 'Purchase Details - Override',
                agreementLabel: 'Sign Agreement - Override',
                paymentLabel: 'Submit Payment - Override',
            },
            warnings: {
                pickShares: 'Please pick number of shares - Override',
            },
        },
        payment: PurchasePaymentI18n,
        pymtEdit: {
            add: PaymentEditAddI18n,
            list: PaymentEditListI18n,
        },
        regCfLimit: PurchaseRegCfI18n,
    },
};
